import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import './veggieBurgerButton.scss';
function VeggieBurgerButton({ children, label, ref, ...otherProps }) {
    return (_jsxs("button", { className: "component-veggie-burger-button", ref: ref, ...otherProps, children: [_jsx("span", { className: "visually-hidden", children: label }), children] }));
}
VeggieBurgerButton.defaultProps = {
    'aria-haspopup': false,
};
export default VeggieBurgerButton;
